export default "__VITE_ASSET__DFvM2iau__"